import { PagosTable, PAGOS_TABLE_SCOPE } from '../../pagos/components/PagosTable';

interface ClientePagosListProps {
  clienteId: number;
}

export function ClientePagosList({ clienteId }: ClientePagosListProps) {
  return <PagosTable scope={PAGOS_TABLE_SCOPE.CLIENTE} clienteId={clienteId} />;
}
